export default {

  SUPERADMIN: 'role_001',

  ORGANIZATION_ADMIN: 'role_002',

  ORGANIZATION_USER: 'role_003',

  SCANNING_ADMIN: 'role_004',

  BINDEZ_ADMIN: 'role_005',

};